module.exports = __webpack_public_path__ + "img/hasselt-3.e6270b35.jpg";